module.exports = __webpack_public_path__ + "media/flag.4678a937.mp4";